import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../me'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Singleton state feature that owns every agent's persisted
 * configuration (agent default + per-conversation overrides) for the
 * current zone. Lives at the root injector so it survives group/
 * conversation switches and is shared across every assistant UI.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    const api = ngCore.inject(Api)
    const meFeature = ngCore.inject(me.Feature)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'AgentConfiguration',
      selectors: () => new Selectors(this),
    })

    this.registerEffects(
      effects.executeLoad(api, meFeature),
      effects.executeSave(api, meFeature),
      effects.executeDeleteOverride(api, meFeature),
      effects.startEditingTriggerLoad(),
    )
  }
}
